"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Label = exports.ChipType = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let Label = exports.Label = /*#__PURE__*/function (Label) {
  Label["Dismiss"] = "Dismiss";
  return Label;
}({});
const ChipType = exports.ChipType = {
  CAUTION: "caution",
  INFORMATION: "information",
  NEGATIVE: "negative",
  POSITIVE: "positive"
};
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Chip](https://vanillaframework.io/docs/patterns/chip).
 *
 * It can be used to display a small value attached to a component.
 */
const Chip = _ref => {
  let {
    appearance,
    lead = "",
    onClick,
    onDismiss,
    quoteValue,
    selected,
    subString = "",
    value,
    ...props
  } = _ref;
  // When user tabs over chip and presses Enter or Space key, chip will trigger
  // click functionality
  const onKeyDown = e => {
    // The " " value is what is returned for the spacebar
    if (e.key === " " || e.key === "Enter") {
      if (typeof onClick === "function") {
        onClick({
          lead: lead,
          value: value
        });
      }
    }
  };
  const chipValue = (0, _utils.highlightSubString)(value, subString).text;
  const chipContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, lead && /*#__PURE__*/_react.default.createElement("span", {
    className: "p-chip__lead"
  }, lead.toUpperCase()), /*#__PURE__*/_react.default.createElement("span", {
    className: "p-chip__value",
    dangerouslySetInnerHTML: {
      __html: quoteValue ? "'".concat(chipValue, "'") : chipValue
    }
  }));
  const chipClassName = (0, _classnames.default)({
    ["p-chip--".concat(appearance)]: !!appearance,
    "p-chip": !appearance
  }, props.className);
  if (onDismiss) {
    return /*#__PURE__*/_react.default.createElement("span", _extends({}, props, {
      className: chipClassName
    }), chipContent, /*#__PURE__*/_react.default.createElement("button", {
      className: "p-chip__dismiss",
      onClick: onDismiss,
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "p-icon--close"
    }, Label.Dismiss)));
  } else {
    return /*#__PURE__*/_react.default.createElement("button", _extends({}, props, {
      "aria-pressed": selected,
      className: chipClassName,
      onClick: onClick,
      onKeyDown: e => onKeyDown(e),
      type: "button"
    }), chipContent);
  }
};
var _default = exports.default = Chip;